export default "/assets/images/mila-circle.d0bc48529cf41aea.png";